import { render, staticRenderFns } from "./PatioLocal.vue?vue&type=template&id=24e3bf69&"
import script from "./PatioLocal.vue?vue&type=script&lang=js&"
export * from "./PatioLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports